<template>
    <a-layout class="provisioning-layout">
        <a-row>
            <ProvisioningHeader />
            <ProvisioningTitle>
                <template #title>
                    <h3 class="title_font_Weight">輸入開通資料</h3>
                </template>
                <template #subTitle>
                    <p class="sub_title_width">
                        此裝置 (裝置碼)尚未完成開通，請輸入以下資訊完成開通程序：
                    </p>
                </template>
            </ProvisioningTitle>
            <ProvisioningIdentidy />
            <ProvisioningOpenDeviceButton @responseStatus="getResponseMsg" @loading="isLoadingChanged"/>
            <ModalApiResultMsg
            :visible="responseMsgObj.visible"
            :title="responseMsgObj.title"
            :okText="responseMsgObj.okText"
            :cancelText="responseMsgObj.cancelText"
            :msgClass="responseMsgObj.msgClass"
            :okCallback="responseMsgObj.msgClass === 'msg_error_modal' ? callPhoneNumber : hideModal"
            :cancelCallback="hideModal">
            <p>{{responseMsgObj.detailText}}</p>
            </ModalApiResultMsg>
            <ProvisioningLoading :status="isLoading" text="資料傳送中，請稍候"/>
        </a-row>
    </a-layout>
</template>

<script>
    import ProvisioningHeader from "../../components/deviceProvision/ProvisioningHeader.vue";
    import ProvisioningTitle from "../../components/deviceProvision/ProvisioningTitle.vue";
    import ProvisioningIdentidy from "../../components/deviceProvision/ProvisioningIdentidy.vue";
    import ProvisioningOpenDeviceButton from "../../components/deviceProvision/ProvisioningOpenDeviceButton.vue";
    import ModalApiResultMsg from "../../components/modal/ModalApiResultMsg.vue";
    import ProvisioningLoading from "@/components/deviceProvision/ProvisioningLoading.vue";
    import { mixinModalMethods } from "../../utils/mixins";

    export default {
        name: 'ProvisioningIdentidyInfoContainer',
        components: {
            ProvisioningLoading,
            ProvisioningHeader,
            ProvisioningTitle,
            ProvisioningIdentidy,
            ProvisioningOpenDeviceButton,
            ModalApiResultMsg,
        },
        mixins: [ mixinModalMethods ],
        data(){
          return{
            isLoading: false,
          }
        },
        methods:{
          isLoadingChanged(status) {
            this.isLoading = status;
          }
        }
    }
</script>
